module.exports = __webpack_public_path__ + "static/media/Australia.99283036.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/Australia.jpg
// module id = 994
// module chunks = 0